import _ from "lodash";
import { mainChannels } from "@/configuration/channelConfiguration";
import {
  setCKEditorSourceEditing,
  setCKEditorPrincipalColorPalette
} from "@/helpers/commonHelper";

export default {
  SET_SELECTED_PRINCIPAL: (state, newValue) => {
    state.selectedPrincipal = newValue;
    localStorage.setItem("selectedPrincipal", JSON.stringify(newValue));
    setCKEditorPrincipalColorPalette();
  },
  SET_FEATURE_GROUPS(state, featureGroups) {
    state.featureGroups = featureGroups;
  },
  SET_FEATURE_GROUPS_FOR_EVENTS(state, featureGroupsForEvents) {
    state.featureGroupsForEvents = featureGroupsForEvents;
  },
  SET_FEATURE_GROUPS_FOR_NEWS(state, featureGroupsForNews) {
    state.featureGroupsForNews = featureGroupsForNews;
  },
  SET_GLOBAL_FEATURE_GROUPS(state, globalFeatureGroups) {
    state.globalFeatureGroups = globalFeatureGroups;
  },
  SET_MODULES(state, modules) {
    state.modules = modules;
  },
  SET_ALL_MODULES(state, modules) {
    state.allModules = modules;
  },
  SET_PRINCIPALS(state, principals) {
    state.principals = principals;
  },
  SET_PRINCIPAL_LIST(state, principals) {
    state.principalList = principals;
  },
  SET_API_KEYS(state, apiKeys) {
    state.apiKeys = apiKeys;
  },
  SET_MAPS_API_KEYS(state, mapsApiKeys) {
    state.mapsApiKeys = mapsApiKeys;
  },
  SET_MAPS_CONFIG(state, mapsConfig) {
    state.mapsConfig = mapsConfig;
  },
  SET_NEWS_API_KEYS(state, newsApiKeys) {
    state.newsApiKeys = newsApiKeys;
  },
  SET_EVENTS_API_KEYS(state, eventsApiKeys) {
    state.eventsApiKeys = eventsApiKeys;
  },
  SET_KIS_API_KEYS(state, kisApiKeys) {
    state.kisApiKeys = kisApiKeys;
  },
  SET_AD_MANAGER_API_KEYS(state, adManagerApiKeys) {
    state.adManagerApiKeys = adManagerApiKeys;
  },
  SET_LLM_API_KEYS(state, llmApiKeys) {
    state.llmApiKeys = llmApiKeys;
  },
  SET_CURRENT_USER(state, currentUser) {
    state.currentUser = currentUser;
    setCKEditorSourceEditing();
  },
  SET_ALL_USERS(state, users) {
    state.users = users;
  },
  SET_GLOBAL_EO_CONFIG(state, config) {
    state.globalEoConfig = config;
  },
  SET_GROUPS(state, groups) {
    state.groups = groups;
  },
  SET_OAUTH_CLIENTS(state, oAuthClients) {
    state.oAuthClients = oAuthClients;
  },
  SET_THIRD_PARTY_SYSTEMS(state, thirdPartySystems) {
    state.thirdPartySystems = thirdPartySystems;
  },
  SET_GLOBAL_CONFIG(state, globalConfig) {
    _.merge(state.globalConfig, globalConfig);
    if (!globalConfig?.summerSeasonRange?.length) {
      state.globalConfig.summerSeasonRange = [];
      state.globalConfig.summerSeasonRange.reverse().reverse();
    }
    state.globalConfig.apiKeys = globalConfig.apiKeys;
    if (globalConfig.favoriteFeatures) {
      state.globalConfig.favoriteFeatures = [...globalConfig.favoriteFeatures];
    }
  },
  SET_CATEGORIES(state, categories) {
    state.categories = categories;
    categories.forEach(cat => {
      state.categoriesById[cat._id] = cat.title;
    });
  },
  SET_MAPPING_FIELDS(state, mappingFields) {
    state.mappingFields = mappingFields;
  },
  SET_CATEGORY_GROUPS(state, categoryGroups) {
    state.categoryGroups = categoryGroups;
    categoryGroups.forEach(cat => {
      state.categoryGroupsById[cat._id] = cat.title;
    });
  },
  SET_CATEGORY_TYPES(state, categoryTypes) {
    state.categoryTypes = categoryTypes;
    categoryTypes.forEach(cat => {
      state.categoryTypesById[cat._id] = cat.title;
    });
  },
  SET_SNACKBAR(state, value) {
    state.snackbar = value;
  },
  SET_SNACKBAR_COLOR(state, snackbarColor) {
    state.snackbarColor = snackbarColor;
  },
  SET_SNACKBAR_TEXT(state, snackbarText) {
    state.snackbarText = snackbarText;
  },
  SET_NAVBAR_EXPANDED(state, isExpanded) {
    state.navbarExpanded = !!isExpanded;
  },
  SET_CITIES(state, cities) {
    state.cities = cities;
  },
  SET_EXPORT_CONFIG(state, exportConfigs) {
    state.exportConfigs = exportConfigs;
  },
  SET_EXPORT_CONFIG_TOTAL(state, total) {
    state.exportConfigsTotal = total;
  },
  SET_ROLE_CATEGORIES(state, roleCategories) {
    state.roleCategories = roleCategories;
  },
  SET_EVENT_STATISTICS(state, eventStatistics) {
    state.eventStatistics = eventStatistics;
  },
  SET_ALLEVENTS_IDS(state, allIds) {
    state.allEventIds = allIds;
  },
  SET_EVENTS(state, events) {
    state.events = events;
  },
  SET_EVENT_COUNT(state, count) {
    state.eventCount = count;
  },
  SET_ALL_EXTERN_EVENTS_IDS(state, allIds) {
    state.allExternEventIds = allIds;
  },
  SET_EXTERN_EVENTS(state, events) {
    state.externEvents = events;
  },
  SET_EXTERN_EVENT_COUNT(state, count) {
    state.externEventCount = count;
  },
  SET_EVENT_DUPLICATES(state, event) {
    state.eventDuplicates = event;
  },
  SET_CATEGORY_GROUPS_FOR_EVENTS(state, categoryGroups) {
    state.categoryGroupsForEvents = categoryGroups;
  },
  SET_ORGANIZER(state, { organizer, count }) {
    state.organizerById = {};
    state.organizer = [];
    state.locationsById = {};
    state.locations = [];

    organizer.forEach(o => {
      if (o.type.includes("operator")) {
        state.organizerById[o._id] = o.title;
        state.organizer.push(o);
      }
      if (o.type.includes("location")) {
        state.locationsById[o._id] = o.title;
        state.locations.push(o);
      }
    });
    state.oplocCount = count;
    state.oplocs = organizer;
  },
  SET_ORGANIZER_CITIES(state, organizerCities) {
    state.organizerCities = organizerCities;
  },
  SET_EVENTS_CONFIG(state, eventConfig) {
    state.eventConfig = eventConfig;
  },
  SET_NEWS_CONFIG(state, newsConfig) {
    state.newsConfig = newsConfig;
  },
  SET_LLM_CONFIG(state, llmConfig) {
    state.llmConfig = llmConfig;
  },
  SET_AD_MANAGER_CONFIG(state, adManagerConfig) {
    state.adManagerConfig = adManagerConfig;
  },
  SET_RELATED_NEWS(state, newsArray) {
    state.relatedNews = newsArray;
  },
  SET_AUTOCOMPLETE_NEWS(state, newsArray) {
    newsArray.forEach(item => {
      state.autocompleteNews.push(item);
    });
  },
  SET_ISSUES(state, issues) {
    state.issues = issues;
  },
  SET_NEWS_FEATURE_GROUPS(state, featureGroups) {
    state.newsFeatureGroups = featureGroups;
  },
  SET_NEWS_FEATURES(state, features) {
    state.newsFeatures = features;
  },
  SET_NEWS_ARTICLE_TYPES(state, articleTypes) {
    state.newsArticleTypes = articleTypes;
  },
  SET_NEWS_APP_CONTENT_TYPES(state, appContentTypes) {
    state.newsAppContentTypes = appContentTypes;
  },
  SET_EVENTS_APP_CONTENT_TYPES(state, appContentTypes) {
    state.eventsAppContentTypes = appContentTypes;
  },
  SET_MOMENTS_FOR_EVENT(state, momentsForEvent) {
    // default alternative_content
    const alternative_content = {};
    mainChannels.forEach(c => {
      alternative_content[c.value] = {
        description: "",
        short_description: ""
      };
    });
    // fill default alternative_content if not defined
    momentsForEvent.forEach(m => {
      if (!m.alternative_content) {
        m.alternative_content = alternative_content;
      }
    });

    state.momentsForEvent = momentsForEvent;
  },
  SET_REGIONS(state, regions) {
    state.regions = regions;
  },
  SET_STATISTICS(state, statistics) {
    state.poiStatistics = statistics;
  },
  SET_REGION_POIS(state, pois) {
    state.regionPois = pois;
  },
  SET_HOLIDAYS(state, holidays) {
    state.holidays = holidays;
  },
  SET_VACATIONS(state, vacations) {
    state.vacations = vacations;
  },
  SET_DEPARTMENT_COUNT(state, count) {
    state.departmentCount = count;
  },
  SET_DEPARTMENT(state, departments) {
    state.departments = departments;
  },
  SET_PERSON_COUNT(state, count) {
    state.personCount = count;
  },
  SET_PERSONS(state, persons) {
    state.persons = persons;
  },
  SET_SUBJECT_AREA_COUNT(state, count) {
    state.subjectAreaCount = count;
  },
  SET_SUBJECT_AREAS(state, subjectAreas) {
    state.subjectAreas = subjectAreas;
  },

  SET_FACILITY_COUNT(state, count) {
    state.facilityCount = count;
  },
  SET_FACILITIES(state, facilities) {
    state.facilities = facilities;
  },
  SET_TASK_COUNT(state, count) {
    state.taskCount = count;
  },
  SET_TASKS(state, tasks) {
    state.tasks = tasks;
  },
  SET_RELATED_TASKS(state, tasksArray) {
    state.relatedTasks = tasksArray;
  },
  SET_AUTOCOMPLETE_TASKS(state, tasksArray) {
    tasksArray.forEach(item => {
      state.autocompleteTasks.push(item);
    });
  },
  SET_DEFECTS(state, defects) {
    state.defects = defects;
  },
  SET_DEFECT_STATISTICS(state, defectStatistics) {
    state.defectStatistics = defectStatistics;
  },
  SET_DEFECT_COUNT(state, count) {
    state.defectCount = count;
  },
  SET_DEFECT_CATEGORIES(state, categories) {
    state.defectCategories = categories;
  },
  SET_COMMITTEE_COUNT(state, count) {
    state.committeeCount = count;
  },
  SET_COMMITTEES(state, committees) {
    state.committees = committees;
  },
  SET_SERVICE_PACKAGE_COUNT(state, count) {
    state.servicePackageCount = count;
  },
  SET_SERVICE_PACKAGES(state, packages) {
    state.servicePackages = packages;
  },
  SET_ACCOMMODATION_TYPE_COUNT(state, count) {
    state.accommodationTypeCount = count;
  },
  SET_ACCOMMODATION_TYPES(state, types) {
    state.accommodationTypes = types;
  },
  SET_BOOKING_FEATURE_GROUPS(state, featureGroups) {
    state.bookingFeatureGroups = featureGroups;
  }
};
